__turbopack_context__.v({
  "previewQuestionItem": "PreviewQuestionItem-module__45mxxq__previewQuestionItem",
  "previewQuestionItemHighlighted": "PreviewQuestionItem-module__45mxxq__previewQuestionItemHighlighted",
  "previewQuestionItemL2": "PreviewQuestionItem-module__45mxxq__previewQuestionItemL2",
  "previewQuestionItemL3": "PreviewQuestionItem-module__45mxxq__previewQuestionItemL3",
});
